import { UserVoiceSearchTeam, } from './components/SearchInContextFeedbackDialog';
import { createLazyComponent, LazyModule, preloadScriptChunk } from 'owa-bundling';
preloadScriptChunk('SearchDiagnosticsView');
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "SearchDiagnostics" */ './lazyIndex');
});
export var SearchInContextFeedbackDialog = createLazyComponent(lazyModule, function (m) { return m.SearchInContextFeedbackDialog; });
export { UserVoiceSearchTeam };
//# sourceMappingURL=index.js.map